import { render, staticRenderFns } from "./EventHistoryTable.vue?vue&type=template&id=26c5df17&"
import script from "./EventHistoryTable.vue?vue&type=script&lang=js&"
export * from "./EventHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./EventHistoryTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDataTable,VSheet,VSkeletonLoader})
